import {
  ActionIcon,
  Box,
  Container,
  Divider,
  Group,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandAirbnb,
  IconBrandFacebook,
  IconBrandInstagram,
} from "@tabler/icons-react";
import { GoldseamShimmerLink } from "@goldseam/ui";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { bookingOptions, socialMediaLinks } from "@/constants";
import { trackEvent } from "@/tracking";

const handleClick = (link: string, label: string) => {
  trackEvent("Footer Link Click", { destination: label });
  window.open(link, "_blank", "noopener,noreferrer");
};

export const BraouFooter = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      pt="xl"
      pb="lg"
      px="md"
      style={{
        background:
          "linear-gradient(180deg, transparent 0%, light-dark(rgba(55,182,255,0.06), rgba(15,41,76,0.4)) 100%)",
      }}
    >
      <Container size="xl">
        <Divider mb="lg" opacity={0.4} />
        <Group justify="space-between" gap="lg" wrap="wrap">
          <Stack gap={2}>
            <Text fw={600} ff='"Fraunces", serif'>
              Villa Braou
            </Text>
            <Group gap={4} align="center">
              <Text size="xs" c="dimmed">
                © {year}{" "}
              </Text>
              <GoldseamShimmerLink
                newWindow
                utm={{
                  source: "villa_brauou",
                  medium: "footer",
                  campaign: "branding",
                }}
              />
            </Group>
          </Stack>
          <Group gap="xs">
            <Tooltip label="Instagram" withArrow>
              <ActionIcon
                variant="subtle"
                color="blossom"
                size="lg"
                radius="xl"
                onClick={() =>
                  handleClick(socialMediaLinks.instagram, "Instagram")
                }
                aria-label="Instagram"
              >
                <IconBrandInstagram size={20} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Facebook" withArrow>
              <ActionIcon
                variant="subtle"
                color="sea"
                size="lg"
                radius="xl"
                onClick={() =>
                  handleClick(socialMediaLinks.facebook, "Facebook")
                }
                aria-label="Facebook"
              >
                <IconBrandFacebook size={20} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Airbnb" withArrow>
              <ActionIcon
                variant="subtle"
                color="blossom"
                size="lg"
                radius="xl"
                onClick={() => handleClick(bookingOptions.airbnb.url, "Airbnb")}
                aria-label="Airbnb"
              >
                <IconBrandAirbnb size={20} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Booking.com" withArrow>
              <ActionIcon
                variant="subtle"
                color="sea"
                size="lg"
                radius="xl"
                onClick={() =>
                  handleClick(bookingOptions.bookingcom.url, "Booking.com")
                }
                aria-label="Booking.com"
              >
                <FontAwesomeIcon
                  icon={bookingOptions.bookingcom.icon}
                  style={{ fontSize: 20 }}
                />
              </ActionIcon>
            </Tooltip>
          </Group>
        </Group>
      </Container>
    </Box>
  );
};

export default BraouFooter;
